import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListHistory(authorization, filter) {
  const url = `${API_URL}/admin/transaction/purchasing-history`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListCreditPurchaseHistory(authorization, filter) {
  const url = `${API_URL}/admin/transaction/credit-transaction-history`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getTotalHistory(authorization, filter) {
  const url = `${API_URL}/admin/transaction/total-purchasing`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getListSubscriptionHistory(authorization, filter) {
  const url = `${API_URL}/admin/transaction/subscription-transaction-history`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getTotalSubscriptionHistory(authorization, filter) {
  const url = `${API_URL}/admin/transaction/subscription-revenue`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getGrossSubscriptionHistory(authorization, filter) {
  const url = `${API_URL}/admin/transaction/gross-revenue`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getListRedemptionHistory(authorization, filter) {
  const url = `${API_URL}/admin/transaction/redemption-history`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}




// WEBPACK FOOTER //
// ./src/services/transaction-admin.js